<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-variable`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.25 13.8347C14.6172 13.8347 14.9149 14.1326 14.915 14.4998C14.915 14.8671 14.6173 15.1648 14.25 15.1648H1.75C1.38273 15.1648 1.08496 14.8671 1.08496 14.4998C1.0851 14.1326 1.38282 13.8347 1.75 13.8347H14.25ZM12.1826 1.05545C12.4285 0.782757 12.8493 0.760818 13.1221 1.00662C13.3944 1.2525 13.4165 1.67339 13.1709 1.94607L9.09277 6.47048L12.7744 10.5554C13.0197 10.8283 12.9982 11.2492 12.7256 11.4949C12.4529 11.7404 12.032 11.7183 11.7861 11.4461L7.80078 7.02322L3.81738 11.4461C3.57157 11.7184 3.15063 11.7403 2.87793 11.4949C2.60526 11.2492 2.58366 10.8283 2.8291 10.5554L6.90625 6.03005L3.22656 1.94607C2.98076 1.67328 3.0027 1.25249 3.27539 1.00662C3.54814 0.761061 3.96804 0.782951 4.21387 1.05545L8.19727 5.47634L12.1826 1.05545Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineVariable',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
